/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Picker_ClearInputs */

const en_picker_clear = /** @type {(inputs: Picker_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear dates`)
};

/**
* | output |
* | --- |
* | "Clear dates" |
*
* @param {Picker_ClearInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const picker_clear = /** @type {((inputs?: Picker_ClearInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Picker_ClearInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_picker_clear(inputs)
});